import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { OrderOutput } from 'core/http/project';
import { ownedError } from 'core/utils/owned-error';

@Component({
  selector: 'app-order-id',
  templateUrl: './order-id.component.html',
  styleUrls: ['order-id.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class OrderIdComponent {
  private _order?: OrderOutput;

  @Input() link = new Array<string>();
  @Input() skeletonView = false;

  @Input()
  set order(o: OrderOutput) {
    this._order = o;
  }

  get order(): OrderOutput {
    if (!this._order) {
      throw ownedError(new Error('Order is not initialized'));
    }

    return this._order;
  }
}
